var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg120(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "182px",
    height: "397px",
    viewBox: "0 0 182 397",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198.145 247.705C289.824 247.705 364.145 173.385 364.145 81.7053C364.145 22.7713 238.756 -13.9163 141.318 5.00845C87.1795 15.5236 79.6783 62.1301 35.346 80.989C-2.39396 97.0435 -15.6526 158.795 24.3594 201.14C67.4023 246.691 150.632 247.705 198.145 247.705Z",
    transform: "matrix(0.8660254 -0.5 0.5 0.8660254 -257.53326 182.07227)",
    id: "Oval",
    fill: "#98E2D6",
    fillRule: "evenodd",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg120);
export default __webpack_public_path__ + "static/media/120.9e9fa46c010b69bff91fe6aba5545714.svg";
export { ForwardRef as ReactComponent };